import React from "react";
import { Section, FadeUp, SectionHeading, CtaButton } from "./primitives";
import { offerFeatures } from "@/data/content";

export const Offer = () => (
  <Section className="bg-zinc-50">
    <div className="max-w-[1100px] mx-auto">
      <FadeUp className="text-center max-w-[720px] mx-auto">
        <SectionHeading>Introducing Lead Guitar Freedom</SectionHeading>
        <p className="mt-6 text-lg md:text-xl text-zinc-600 leading-relaxed">
          Lead Guitar Freedom is a hands-on 60-day coaching program for intermediate rock guitarists who want to
          stop guessing, fix what's holding them back, and finally build the technique and improvisation skills
          to play fast, fluid, expressive solos.
        </p>
      </FadeUp>
      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {offerFeatures.map((f, i) => (
          <FadeUp key={f.title} delay={(i % 3) * 0.05}>
            <div
              data-testid={`offer-card-${i}`}
              className="h-full bg-white border border-zinc-200 rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-[#D90429]/10 text-[#D90429] font-black">
                {i + 1}
              </span>
              <h3 className="mt-4 text-xl font-bold text-zinc-900">{f.title}</h3>
              <p className="mt-2 text-base text-zinc-600 leading-relaxed">{f.text}</p>
            </div>
          </FadeUp>
        ))}
      </div>
      <FadeUp delay={0.1}>
        <div className="mt-14 flex justify-center">
          <CtaButton testid="cta-offer-apply" />
        </div>
      </FadeUp>
    </div>
  </Section>
);
